var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.yaml2soya = void 0;
const js_yaml_1 = __importDefault(require("js-yaml"));
const logger_1 = require("../../services/logger");
const overlays_1 = require("./overlays");
// according to https://www.w3.org/TR/xmlschema11-2
const xsTypes = [
    'string',
    'boolean',
    'decimal',
    'float',
    'double',
    'duration',
    'dateTime',
    'time',
    'date',
    'gYearMonth',
    'gYear',
    'gMonthDay',
    'gDay',
    'gMonth',
    'hexBinary',
    'base64Binary',
    'anyURI',
    'QName',
    'NOTATION',
    'integer',
    'long',
    'int',
    'short',
    'byte',
    'nonNegativeInteger',
    'positiveInteger',
    'unsignedLong',
    'unsignedInt',
    'unsignedShort',
    'unsignedByte',
    'nonPositiveInteger',
    'negativeInteger',
    'normalizedString',
    'token',
    'language',
    'Name',
    'NCName',
    'ENTITY',
    'ID',
    'IDREF',
    'NMTOKEN',
];
const handleBase = (doc, base) => {
    const { graph } = doc;
    const baseName = base.name;
    graph.push({
        '@id': baseName,
        '@type': "owl:Class",
        'subClassOf': base.subClassOf || 'soya:Base',
    });
    for (const attrName in base.attributes) {
        const specifiedDataType = base.attributes[attrName];
        // for matching, also lowercase all xsTypes
        const xsdIndex = xsTypes.map(x => x.toLowerCase()).indexOf(specifiedDataType.toLowerCase());
        const dataType = xsdIndex !== -1 ?
            `xsd:${xsTypes[xsdIndex]}` :
            specifiedDataType;
        graph.push({
            '@id': attrName,
            '@type': 'owl:DatatypeProperty',
            'domain': base.name,
            'range': dataType,
        });
    }
    if (Array.isArray(base.subClasses)) {
        for (const subBase of base.subClasses) {
            // set subClassOf implicitly
            subBase.subClassOf = baseName;
            handleBase(doc, subBase);
        }
    }
};
const yaml2soya = (yamlContent, contextUrl, baseUrl) => __awaiter(this, void 0, void 0, function* () {
    const yaml = js_yaml_1.default.load(yamlContent);
    if (!yaml || typeof yaml !== 'object') {
        logger_1.logger.error('Can not parse YAML!');
        return;
    }
    const { meta, content } = yaml;
    const doc = {
        "@context": {
            "@version": 1.1,
            "@import": contextUrl,
            "@base": `${baseUrl}/${meta.name}/`,
        },
        graph: [],
    };
    if (meta.namespace && typeof meta.namespace === 'object') {
        for (const nsKey in meta.namespace) {
            doc['@context'][nsKey] = meta.namespace[nsKey];
        }
    }
    if (Array.isArray(content.bases))
        for (const base of content.bases) {
            handleBase(doc, base);
        }
    if (Array.isArray(content.overlays))
        for (const overlay of content.overlays) {
            (0, overlays_1.handleOverlay)(doc, overlay);
        }
    // this is where the rename of "graph" to "@graph" happens
    const printable = {
        '@context': doc['@context'],
        '@graph': doc.graph,
    };
    return printable;
});
exports.yaml2soya = yaml2soya;
//# sourceMappingURL=index.js.map